import WalletConnectModal from "./WalletConnectModal";

export default WalletConnectModal;
